(function () {
  if (window.__ssPages) return; window.__ssPages = true;

  // ---------- product gallery (mobile swipe, thumbs, counter) + lightbox ----------
  function initGallery(root) {
    (root || document).querySelectorAll('[data-ss-gal]').forEach(function (gal) {
      if (gal.dataset.ready) return; gal.dataset.ready = '1';
      var track = gal.querySelector('[data-ss-gal-track]');
      var cur = gal.querySelector('[data-ss-gal-cur]');
      var thumbs = gal.querySelectorAll('[data-ss-thumb]');
      var items = track ? track.children : [];
      var mobile = function () { return window.matchMedia('(max-width: 989px)').matches; };
      if (track) {
        track.addEventListener('scroll', function () {
          if (!mobile()) return;
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (cur) cur.textContent = i + 1;
          thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
        }, { passive: true });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = +t.dataset.ssThumb;
          if (items[i]) track.scrollTo({ left: items[i].offsetLeft, behavior: 'smooth' });
        });
      });
      var lb = document.querySelector('[data-ss-lb]');
      gal.querySelectorAll('[data-ss-zoom]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!lb || typeof lb.showModal !== 'function') return;
          lb.showModal(); document.body.classList.add('ss-lock');
          var target = lb.querySelector('#ss-lb-' + b.dataset.ssZoom);
          if (target) target.scrollIntoView({ block: 'start' });
        });
      });
      if (lb && !lb.dataset.ready) {
        lb.dataset.ready = '1';
        var close = function () { lb.close(); document.body.classList.remove('ss-lock'); };
        lb.querySelector('[data-ss-lb-close]').addEventListener('click', close);
        lb.addEventListener('cancel', function () { document.body.classList.remove('ss-lock'); });
        lb.querySelectorAll('.ss-lb__item').forEach(function (it) { it.addEventListener('click', function () { it.classList.toggle('is-zoom'); }); });
      }
    });
  }

  // ---------- sticky add to bag on phones ----------
  function initSticky() {
    var bar = document.querySelector('[data-ss-sticky]');
    var buy = document.querySelector('[data-ss-buy]');
    if (!bar || !buy) return;
    var btn = bar.querySelector('[data-ss-sticky-add]');
    var tick = false;
    var upd = function () {
      tick = false;
      var r = buy.getBoundingClientRect();
      var on = r.bottom < 0;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
    };
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
    var add = bar.querySelector('[data-ss-sticky-add]');
    if (add) add.addEventListener('click', function () {
      var submit = buy.querySelector('[type="submit"]');
      if (submit) submit.click();
    });
  }

  // ---------- product recommendations ----------
  function initRecs() {
    document.querySelectorAll('[data-ss-recs]').forEach(function (el) {
      if (el.dataset.ready || el.querySelector('.ss-rail')) return; el.dataset.ready = '1';
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.ss-recs-inner');
        if (inner && inner.innerHTML.trim()) {
          el.querySelector('.ss-recs-inner').innerHTML = inner.innerHTML;
          document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: {}, bubbles: true }));
          el.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
        } else { el.hidden = true; }
      }).catch(function () { el.hidden = true; });
    });
  }

  // ---------- consignment calculator ----------
  function initCalc(root) {
    (root || document).querySelectorAll('[data-ss-calc]').forEach(function (c) {
      if (c.dataset.ready) return; c.dataset.ready = '1';
      var tiers = [];
      try { tiers = JSON.parse(c.dataset.tiers); } catch (e) {}
      var inp = c.querySelector('input'); var out = c.querySelector('[data-ss-calc-out]'); var note = c.querySelector('[data-ss-calc-note]');
      var rows = c.querySelectorAll('tbody tr');
      var fmt = function (n) { return '£' + Math.round(n).toLocaleString('en-GB'); };
      var upd = function () {
        var v = Math.max(0, parseFloat(inp.value) || 0);
        var idx = tiers.findIndex(function (t) { return t.max === null || v <= t.max; });
        if (idx < 0) idx = tiers.length - 1;
        var pct = tiers[idx] ? tiers[idx].pct : 0;
        out.textContent = fmt(v * (1 - pct / 100));
        if (note) note.textContent = pct + '% commission on a ' + fmt(v) + ' sale. You keep ' + (100 - pct) + '%.';
        rows.forEach(function (r, k) { r.classList.toggle('is-cur', k === idx); });
      };
      inp.addEventListener('input', upd); upd();
    });
  }

  // ---------- share: copy link ----------
  function initShare() {
    document.querySelectorAll('[data-ss-copy]').forEach(function (b) {
      if (b.dataset.ready) return; b.dataset.ready = '1';
      b.addEventListener('click', function () {
        var url = b.dataset.ssCopy;
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { b.textContent = 'Link copied'; }).catch(function () {});
      });
    });
  }

  function init() { initGallery(); initSticky(); initRecs(); initCalc(); initShare(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initGallery(e.target); initCalc(e.target); });
})();
